<template>
<div class="common-sider-menu">
  <ul>
    <li
      v-for="item of menuList"
      :key="item.index"
      :track-by="item.index"
      :title="item.title"
    >
      <div
        v-if="item.type === 'group'"
        :class="item.classList"
        class="menu-group">
        {{ item.title }}
      </div>

      <div v-if="item.type !== 'group'">
        <div
          :class="[
            'menu-item',
            'ellipsis',
            { active: item.active },
            item.classList
          ]"
          @click="onClick(item)"
        >
          <a
            :href="item.url"
            style="display: block;"
            @click.prevent>

            <slot name="nav-item" :item="item">
              {{item.title}}
            </slot>
          </a>

        </div>

        <div>
          <ul class="sub-menu" v-if="item.subMenu && item.subMenu.length > 0 && item.expand">
            <li
              v-for="subItem of item.subMenu"
              :key="subItem.index"
              :track-by="subItem.index"
              :class="['menu-item', 'ellipsis', { active: subItem.active }]"
              :title="subItem.title"
              @click="onClick(subItem)"
            >
              <a
                :href="subItem.url"
                style="display: block;"
                @click.prevent>
                <slot name="nav-item" :item="subItem">
                  {{subItem.title}}
                </slot>
              </a>
            </li>
          </ul>
        </div>
     </div>
    </li>
  </ul>
</div>
</template>

<script>
const loop = (menus, selected) =>
  menus.map(item => {
    const menu = {
      ...item,
      active: selected.indexOf(item.index) > -1,
    };
    if (item.subMenu && item.subMenu.length > 0) {
      menu.subMenu = loop(item.subMenu, selected);
      menu.expand = menu.subMenu.some(m => m.active) || menu.active;
    }
    return menu;
  });

export default {
  props: {
    selected: {
      type: Array,
      default() {
        return [];
      },
    },
    onClick: {
      type: Function,
      default() {},
    },
    menus: {
      require: true,
      type: Array,
    },
  },
  computed: {
    menuList() {
      return loop(this.menus, this.selected);
    },
  },
};
</script>

<style lang="scss">
@import '../../assets/styles/_variable';

.common-sider-menu {
  ul {
    margin: 0;
    padding: 0;
  }
  li {
    list-style: none;
  }
  .menu-group {
    margin: 0 20px;
    margin-top: 10px;
    padding: 10px 0;
    border-top: 1px solid $borderColor;
    color: #9B9B9B;
    font-size: 12px;
    line-height: 1;
  }
  .menu-item {
    height: 40px;
    padding-left: 20px;
    color: $mainColor;
    font-size: 14px;
    line-height: 40px;
    cursor: pointer;

    & > a,
    & > a:active,
    & > a:visited,
    & > a:hover,
    & > a:focus {
      color: inherit;
    }

    &:hover {
      background: #F0F0F0;
    }
  }
  .sub-menu {
    .menu-item {
      height: 34px;
      line-height: 34px;
      padding-left: 34px;
      color: #535D71;
      font-size: 12px;
      padding-right: 14px;
      &:hover {
        background: #F0F0F0;
      }
    }
  }
}
</style>
